import { bannerFromEmailOutcome, bannerFromPlatformOutcome, emailOutcomeNavigatesAway, platformOutcomeNavigatesAway } from './outcomes'
import { INewSignupState, NewSignupAction } from './types'

export const initialState: INewSignupState = {
  banner: { kind: 'none' },
  busy: null,
}

export const reducer = (state: INewSignupState, action: NewSignupAction): INewSignupState => {
  switch (action.type) {
    case 'submitted':
      return { banner: { kind: 'none' }, busy: action.source }

    // An outcome that navigates away keeps the control busy, so the form is not briefly
    // re-enabled underneath a navigation already in flight.
    case 'emailResolved':
      return {
        banner: bannerFromEmailOutcome({ outcome: action.outcome, email: action.email }),
        busy: emailOutcomeNavigatesAway(action.outcome) ? state.busy : null,
      }

    case 'platformResolved':
      return {
        banner: bannerFromPlatformOutcome(action.outcome),
        busy: platformOutcomeNavigatesAway(action.outcome) ? state.busy : null,
      }

    case 'disposableEmailRejected':
      return { banner: { kind: 'disposableEmail' }, busy: null }

    case 'notWorkspaceAccountRejected':
      return { banner: { kind: 'notWorkspaceAccount' }, busy: null }

    case 'signupCancelled':
      return { banner: { kind: 'signupCancelled', platform: action.platform }, busy: null }

    // Open or closed, the tab is out of this page's sight, so the form is freed either way. An
    // answer that still arrives from it marks the page busy again.
    case 'platformTabOutOfSight':
      return { banner: { kind: 'continueInPlatformTab', platform: action.platform }, busy: null }

    case 'platformSigninRejected':
      return { banner: { kind: 'platformSigninRejected', platform: action.platform }, busy: null }

    case 'companyExistsDetected':
      return { banner: { kind: 'companyExists', platform: action.platform, organizationName: action.organizationName, email: action.email }, busy: null }

    case 'accessRequestResolved':
      return { ...state, banner: action.banner }

    case 'bannerCleared':
      return state.banner.kind === 'none' ? state : { ...state, banner: { kind: 'none' } }

    case 'released':
      return state.busy === null ? state : { ...state, busy: null }

    default:
      return state
  }
}
